import { Component, Input } from '@angular/core';
import { BaseComponent } from '../../pages/base/base.component';

@Component({
  selector: 'app-generic-message-modal',
  templateUrl: './generic-message-modal.component.html',
  styleUrls: ['./generic-message-modal.component.css']
})
export class GenericMessageModalComponent extends BaseComponent {
  @Input() title!: any;
  @Input() displayMessage!: any;
  @Input() isShowButton!: boolean;
  @Input() buttonClickCallback!: any;
  @Input() buttonText!: string;

  public isHeaderVisible: boolean = true;

  constructor() {
    super();
  }

  public dialogClose() {

  }
}
